import { render, staticRenderFns } from "./AddContactUnified.vue?vue&type=template&id=5490e3ef&scoped=true&"
import script from "./AddContactUnified.vue?vue&type=script&lang=js&"
export * from "./AddContactUnified.vue?vue&type=script&lang=js&"
import style0 from "./AddContactUnified.vue?vue&type=style&index=0&id=5490e3ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5490e3ef",
  null
  
)

export default component.exports